import { render, staticRenderFns } from "./OrderIncomes.vue?vue&type=template&id=019ce990&"
import script from "./OrderIncomes.vue?vue&type=script&lang=js&"
export * from "./OrderIncomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports